<template>
  <FullScreenOverlayLoader
    :isLoading="loaderObj.isLoading"
    :message="loaderObj.loaderMsg"
  />
  <!-- title -->
  <div :class="{ 'px-3 lg:px-5 bg-white relative': !isEmbedded }">
    <div
      class="flex flex-row items-center text-2xl md:text-3xl font-bold text-primary pl-2 pt-1 pb-2 relative"
    >
      <!-- Back Button Section (Left) -->
      <div
        v-if="
          formTemplateData.settings &&
          formTemplateData.settings.show_back_button
        "
        class="flex items-center cursor-pointer absolute left-0 z-10"
      >
        <Button
          label="Back"
          icon="pi pi-arrow-left"
          severity="primary"
          rounded
          class="!leading-none mt-2"
          variant="outlined"
          @click="handleTitleClick"
        />
        <!-- <span
          class="pi pi-arrow-circle-left mr-2 !text-[17px] md:!text-2xl"
        ></span> -->
      </div>

      <!-- Title Section (Centered) -->
      <div
        v-if="formTemplateData.settings && formTemplateData.settings.title"
        class="flex-1 flex justify-center"
      >
        <span class="hidden sm:inline">
          {{ formTemplateData.settings.title.lg }}
        </span>
        <span class="sm:hidden">{{ formTemplateData.settings.title.sm }}</span>
      </div>

      <!-- Version Section (Right) -->
      <div
        class="flex items-center space-x-2 absolute right-0"
        v-if="formTemplateData && !isEmbedded"
      >
        <DynamicVersionDisplayComponent
          :tooltip="'Changelog version'"
          :version="formTemplateResponse?.version"
          :icon="'pi pi-database'"
          icon-color="gray"
        />
        <Divider layout="vertical" />
        <DynamicVersionDisplayComponent
          :tooltip="'Form version'"
          :version="formTemplateData?.version"
          :icon="'pi pi-desktop'"
          icon-color="gray"
        />
      </div>
    </div>
    <!-- Stepper Section -->
    <Stepper
      v-model:value="activeStep"
      :key="visiblePages.length"
    >
      <StepList>
        <Step
          v-for="(page, index) in visiblePages"
          :key="index"
          :value="index + 1"
          :data-step="index + 1"
          v-slot="{}"
          :asChild="page.is_show_stepper_title == false"
          @click.capture.stop.prevent="() => handleStepClick(index + 1)"
        >
          <!-- if false then not show the title -->
          <div v-if="page.is_show_stepper_title == false"></div>
          <div v-else>
            {{ page.stepper_title }}
          </div>
        </Step>
      </StepList>
      <StepPanels>
        <StepPanel
          v-for="(page, pageIndex) in visiblePages"
          :key="pageIndex"
          :value="pageIndex + 1"
        >
          <!-- This is hack so that we can use responsive width classes, otheriwse even though we set those classes dynamic in loops, ui doesn't change but by doing this it changes the ui -->
          <div class="flex flex-wrap sm:flex-nowrap sm:items-center hidden">
            <div class="w-full sm:w-3/12">.w-1/2</div>
            <div class="w-full sm:w-9/12">.w-1/2</div>
          </div>
          <!-- Page Content -->
          <div class="overflow-y-auto pb-16">
            <!-- no list mean need to show the page -->
            <PageBuilderComponent
              v-if="page.pageObj && !page.is_list"
              :key="page.page_id"
              :templateData="formTemplateData"
              :page="page"
              :savedResValue="
                Helper.isValueExist(
                  formTemplateResponse && formTemplateResponse.response
                )
                  ? formTemplateResponse.response
                  : {}
              "
              :ref="
                (el) => {
                  if (el) pageBuilderComponents[page.id] = el;
                }
              "
            />
            <!-- if list then choose based on template type -->
            <div v-if="page.is_list">
              <div
                v-if="
                  page.template_type ==
                  Constants.enums.PAGE_TEMPLATE_TYPE.QC_SUMMARY_LIST
                "
              >
                <div
                  v-for="(item, _i) in page.list_items"
                  :key="_i"
                  class="pb-4"
                >
                  <QCSummaryTemplateComponent
                    :thumbnail="item.thumbnail"
                    :title="item.label"
                    :pageData="item || {}"
                    :resData="{}"
                    :resId="getResponseId || null"
                    status="In Progress"
                  />
                </div>
              </div>
              <div
                v-if="
                  page.template_type ==
                  Constants.enums.PAGE_TEMPLATE_TYPE.PROCEDURES_LIST
                "
              >
                <div class="flex items-center gap-6 mb-4">
                  <div
                    class="flex items-center gap-2 bg-blue-50 rounded px-4 py-2 shadow-sm"
                  >
                    <span class="font-semibold text-blue-700">CMA:</span>
                    <span class="text-blue-900">
                      {{ cmaNumber || "N/A" }}
                    </span>
                  </div>
                  <div
                    class="flex items-center gap-2 bg-green-50 rounded px-4 py-2 shadow-sm"
                  >
                    <span class="font-semibold text-green-700">Year:</span>
                    <span class="text-green-900">
                      {{ cmaYear ? cmaYear : "N/A" }}
                    </span>
                  </div>
                </div>
                <div
                  v-for="(item, _i) in page.list_items"
                  :key="_i"
                  class="pb-4"
                >
                  <ProceduresTemplateComponent
                    v-if="item"
                    :pageData="item"
                    :selectedPath="[getFormId, page.id]"
                    :selectedLabels="[]"
                    @update:pageData="updatePageData(pageIndex, _i, $event)"
                    :resId="getResponseId || null"
                    status="test"
                    :savedResValue="
                      Helper.isValueExist(
                        formTemplateResponse && formTemplateResponse.response
                      )
                        ? formTemplateResponse.response
                        : {}
                    "
                  />
                </div>
              </div>
            </div>
            <div
              v-if="
                page.template_type ==
                Constants.enums.PAGE_TEMPLATE_TYPE.ATTENDEES
              "
            >
              <FlraAttendeesComponent
                v-model:dataObj="page.value"
                :pageId="page.id"
                :templateId="getFormId"
              />
            </div>
            <div
              v-if="
                page.template_type ==
                Constants.enums.PAGE_TEMPLATE_TYPE.CARD_LIST
              "
            >
              <CardListComponent
                :dataObj="page"
                :templateData="formTemplateData"
              />
            </div>
          </div>
          <!-- Buttons -->
          <div
            class="flex pt-6 justify-end"
            v-if="
              page.hover_btns &&
              (isEmbedded == true ? showButtons == true : true)
            "
          >
            <!-- Left Buttons -->
            <div
              class="fixed bottom-4 left-5"
              v-if="page.hover_btns.left && page.hover_btns.left.length"
            >
              <div
                v-for="(button, index) in page.hover_btns.left"
                :key="index"
              >
                <Button
                  :label="button.label || ''"
                  :severity="button.severity"
                  :icon="button.icon || ''"
                  @click="
                    onNavigationBtnClick(
                      button.onClick,
                      button.before_event,
                      button.after_event,
                      button.config
                    )
                  "
                />
              </div>
            </div>
            <!-- Right Buttons -->
            <div
              :class="{
                'fixed bottom-4 right-5': !showButtons
              }"
              v-if="page.hover_btns.right && page.hover_btns.right.length"
            >
              <Button
                v-for="(button, index) in page.hover_btns.right"
                v-show="isButtonVisible(button) && !button.hideInForm"
                :key="index"
                :label="button.label || ''"
                :severity="button.severity"
                :icon="button.icon || ''"
                class="ml-3"
                @click="
                  onNavigationBtnClick(
                    button.onClick,
                    button.before_event,
                    button.after_event,
                    button.config
                  )
                "
              />
            </div>
          </div>
        </StepPanel>
      </StepPanels>
    </Stepper>
  </div>

  <AddMoreMenuOptionsComponent
    v-if="addMoreMenuObj.isVisible"
    v-model:visible="addMoreMenuObj.isVisible"
    :pageObj="addMoreMenuObj.pageObj"
    :title="addMoreMenuObj.title"
    :onSaveClick="addMoreMenuObj.onSaveClick"
    :parentTemplateData="formTemplateData"
    :onCancelClick="addMoreMenuObj?.onCancelClick || null"
  />

  <ErrorDialog
    v-if="errorObj.isVisible"
    :visible="errorObj.isVisible"
    :message="errorObj.errorMsg"
    :onConfirm="onErrorDialogClose"
    @update:visible="errorObj.isVisible = $event"
  />
  <ConfirmationDialog
    v-if="confirmationDialogObj.isVisible"
    :showHazardIcon="confirmationDialogObj.showHazardIcon"
    :headerMsg="confirmationDialogObj.headerMsg"
    :visible="confirmationDialogObj.isVisible"
    :message="confirmationDialogObj.message"
    :onConfirm="confirmationDialogObj.onConfirm"
    :onCancel="confirmationDialogObj.onCancel"
    @update:visible="confirmationDialogObj.isVisible = $event"
  />
  <PdfPreviewDialog
    v-if="pdfPreviewObj.isVisible"
    v-model:visible="pdfPreviewObj.isVisible"
    :selected-data="pdfPreviewObj.data"
    :pdf-src="pdfPreviewObj.pdfSrc"
    @download="pdfPreviewObj.onDownload"
    @sendEmail="openSendEmailDialog"
  />
  <!-- Email Dialog -->
  <GenericSendEmailDialog
    v-if="showSendEmailDialog"
    v-model:visible="showSendEmailDialog"
    :document="selectedEmailDoc"
    dialogHeader="Send Email Notification"
    :defaultMessage="selectedEmailDoc.defaultMessage"
    :attachmentNote="'PDF attachment will be included'"
    :showSupervisorOption="selectedEmailDoc.showSupervisor"
    :showMyselfOption="selectedEmailDoc.showMyself"
    @emailSent="onSendEmailSuccess"
    @previewClicked="
      () => {
        if (selectedEmailDoc.pdfSrc) showEmailPreview = true;
      }
    "
  />
  <!-- Dialog for previewing the attached PDF before sending email -->
  <PdfPreviewDialog
    v-if="showEmailPreview"
    v-model:visible="showEmailPreview"
    :selected-data="selectedEmailDoc"
    :pdf-src="selectedEmailDoc.pdfSrc"
    :hideActions="true"
  />
  <PromiseConfirmationDialog />
</template>

<script>
  import {
    defineComponent,
    onMounted,
    ref,
    watch,
    computed,
    toRaw,
    onBeforeUnmount
  } from "vue";
  import FullScreenOverlayLoader from "@/components/FullScreenOverlayLoader.vue";
  import ErrorDialog from "@/components/ErrorDialog.vue";
  import QCSummaryTemplateComponent from "./components/QCSummaryTemplateComponent.vue";
  import ProceduresTemplateComponent from "./components/ProceduresTemplateComponent.vue";
  import PageBuilderComponent from "@/components/PageBuilderComponent.vue";
  import DynamicVersionDisplayComponent from "@/components/DynamicVersionDisplayComponent.vue";
  import GenericSendEmailDialog from "@/components/GenericSendEmailDialog.vue";
  import PromiseConfirmationDialog from "@/components/PromiseConfirmationDialog.vue";
  import Helper from "@/utils/helper";
  import Constants from "@/utils/constants";
  import { useRoute, useRouter } from "vue-router";
  import { useFormTemplateStore } from "@/stores/formTemplateStore";
  import { useFormTemplateResponseStore } from "@/stores/formTemplateResponseStore";
  import { useFormPageStore } from "@/stores/formPageStore";
  import FlraAttendeesComponent from "src/pages/forms/flra/components/FlraAttendees.vue";
  import PdfPreviewDialog from "src/pages/forms/flra/components/PdfPreviewDialog.vue";
  import { storeToRefs } from "pinia";
  import { useDebounceFn } from "@vueuse/core";
  import { useUserStore } from "@/stores/userStore";
  import { useTriggerSettingsStore } from "@/stores/triggerSettingsStore";
  import { useSupabaseStorageUploadStore } from "@/stores/supabaseStorageUploadStore";
  import { usePreDefinedListStore } from "@/stores/preDefinedListStore";
  import { usePromiseDialog } from "@/composables/usePromiseDialog";
  import CardListComponent from "@/components/CardListComponent.vue";
  import AddMoreMenuOptionsComponent from "@/components/AddMoreMenuOptionsComponent.vue";
  export default defineComponent({
    name: "FormTemplatePage",
    props: [
      "id",
      "res",
      "isEmbedded",
      "onEmbeddedAction",
      "shouldValidate",
      "showButtons"
    ],
    emits: ["response-saved", "validation-result"],
    components: {
      ErrorDialog,
      FullScreenOverlayLoader,
      QCSummaryTemplateComponent,
      PageBuilderComponent,
      ProceduresTemplateComponent,
      FlraAttendeesComponent,
      DynamicVersionDisplayComponent,
      PdfPreviewDialog,
      GenericSendEmailDialog,
      PromiseConfirmationDialog,
      CardListComponent,
      AddMoreMenuOptionsComponent
    },

    setup(props, { emit }) {
      const route = useRoute();
      const router = useRouter();
      const activeStep = ref(1);
      const errorObj = ref({
        isVisible: false,
        errorMsg: ""
      });
      const pageBuilderComponents = ref({});
      const localTempStorage = ref({});
      const loaderObj = ref({
        isLoading: false,
        loaderMsg: ""
      });
      const addMoreMenuObj = ref({
        isVisible: false,
        pageObj: null,
        title: "",
        onSaveClick: () => {}
      });

      // Initialize the promise dialog
      const { dialogState: promiseDialogState, showConfirmationDialog } =
        usePromiseDialog();

      const pdfPreviewObj = ref({
        isVisible: false,
        data: null,
        pdfSrc: null,
        fileName: "",
        onDownload: async () => {
          if (!pdfPreviewObj.value.fileName) {
            pdfPreviewObj.value.fileName = Helper.generateFormFileName(
              getFormId.value,
              response.value
            );
          }
          // Download the PDF
          await Helper.downloadToLocal(
            pdfPreviewObj.value.pdfSrc,
            pdfPreviewObj.value.fileName
          );
        }
      });
      const confirmationDialogObj = ref({
        showHazardIcon: false,
        headerMsg: "",
        isVisible: false,
        message: "",
        onConfirm: () => {}
      });
      const formTemplateData = ref({});
      const formTemplateResponse = ref({});
      const formTemplateStore = useFormTemplateStore();
      const { formProgress } = storeToRefs(useFormPageStore());
      const isPageLoading = ref(true);
      const userStore = useUserStore();
      const formTemplateResponseStore = useFormTemplateResponseStore();
      const { templateId } = storeToRefs(formTemplateResponseStore);
      const { response } = storeToRefs(formTemplateResponseStore);
      const showSendEmailDialog = ref(false);
      const selectedEmailDoc = ref({});
      const showEmailPreview = ref(false);
      const requiredSync = ref(false);
      const initialResponseString = ref(null);

      const triggerSettingsStore = useTriggerSettingsStore();

      // Add debounced save function using VueUse's useDebounceFn
      const debouncedSave = useDebounceFn(async () => {
        if (
          props.isEmbedded &&
          !loaderObj.value.isLoading &&
          !isPageLoading.value
        ) {
          await saveFormResponse();
        }
      }, Constants.enums.DEBOUNCE_TIME.MS_500);

      // Watch for changes in form data
      watch(
        response,
        () => {
          if (props.isEmbedded && !isPageLoading.value) {
            debouncedSave();
          }
        },
        { deep: true }
      );

      // Watch for route query changes to handle dynamic URL updates
      watch(
        () => route.query,
        (newQuery, oldQuery) => {
          // Only apply if the form is loaded and there are actual changes
          if (
            !isPageLoading.value &&
            formTemplateData.value &&
            JSON.stringify(newQuery) !== JSON.stringify(oldQuery)
          ) {
            setTimeout(() => {
              applyUrlQueryParamsToFields();
            }, 100);
          }
        },
        { deep: true }
      );

      // Get the form ID from either props or route
      const getFormId = computed(() => {
        return props.id || route.params.id;
      });

      watch(
        getFormId,
        (newVal) => {
          formTemplateResponseStore.templateId = newVal;
        },
        { immediate: true }
      );

      const responseId = ref(null);

      // Get the response ID from either props or route
      const getResponseId = computed(() => {
        return responseId.value || props.res || route.params.res;
      });

      const getPreDefinedList = async () => {
        try {
          await usePreDefinedListStore().getPreDefinedListData({
            fetchAll: true
          });
        } catch (error) {
          throw error;
        }
      };

      // Function to apply URL query parameters to form fields
      const applyUrlQueryParamsToFields = () => {
        try {
          // Get all query parameters from the route using the helper function
          const queryParams = Helper.getQueryPairs(route);

          // Skip if no query parameters
          if (!queryParams || Object.keys(queryParams).length === 0) {
            return;
          }

          // Get the current response object
          const currentResponse = response.value;
          if (!currentResponse || !currentResponse[templateId.value]) {
            return;
          }

          let hasChanges = false;

          // Iterate through all query parameters
          for (const [paramKey, paramValue] of Object.entries(queryParams)) {
            // Use Helper.findAndSetKeyInObject to find and set field values
            const existingValue = Helper.findAndSetKeyInObject(
              currentResponse[templateId.value],
              paramKey
            );

            // Only set the value if it's different from the current value
            if (existingValue !== paramValue) {
              Helper.findAndSetKeyInObject(
                currentResponse[templateId.value],
                paramKey,
                paramValue
              );
              hasChanges = true;
              console.log(`Set field ${paramKey} to value: ${paramValue}`);
            }
          }

          // Update the store if any changes were made
          if (hasChanges) {
            formTemplateResponseStore.setResponse(
              templateId.value,
              currentResponse[templateId.value]
            );

            // Also update field values in the UI components
            updateFieldValuesInUI();
          }
        } catch (error) {
          console.error(
            "Error applying URL query parameters to fields:",
            error
          );
        }
      };

      // Function to update field values in UI components
      const updateFieldValuesInUI = () => {
        try {
          // Get all query parameters from the route using the helper function
          const queryParams = Helper.getQueryPairs(route);

          if (!queryParams || Object.keys(queryParams).length === 0) {
            return;
          }

          // Update field values in all page builder components
          Object.values(pageBuilderComponents.value).forEach((pageBuilder) => {
            if (pageBuilder && pageBuilder.formInputComponents) {
              pageBuilder.formInputComponents.forEach((formInput) => {
                if (formInput && formInput.field) {
                  const fieldId = formInput.field.id;
                  if (queryParams[fieldId]) {
                    // Only set the value if the field doesn't already have a value or if it's different
                    if (
                      !formInput.field.value ||
                      formInput.field.value !== queryParams[fieldId]
                    ) {
                      formInput.field.value = queryParams[fieldId];
                    }
                  }
                }
              });
            }
          });
        } catch (error) {
          console.error("Error updating field values in UI:", error);
        }
      };

      const evaluateClickButtonTriggers = async (buttonType) => {
        try {
          await Helper.evaluateClickButtonTriggers({
            buttonType,
            formId: getFormId.value,
            triggerSettingsStore,
            response: response.value,
            confirmationDialogObj,
            beforeAfterActionsHandler
          });
        } catch (error) {
          console.error("Error in evaluateClickButtonTriggers:", error);
          errorObj.value.isVisible = true;
          errorObj.value.errorMsg = error.message;
          throw error;
        }
      };
      // reset the saved response on unmount
      onBeforeUnmount(() => {
        formTemplateResponseStore.resetResponse();
      });

      onMounted(async () => {
        getPreDefinedList();
        const formId = getFormId.value;
        let _responseId = getResponseId.value;

        if (Helper.isValueExist(formId) && formId.length > 0) {
          let _res = await fetchFormTemplateById();
          if (Helper.isValueExist(_responseId) && _responseId.length > 0) {
            await fetchFormTemplateResponseById(_res);
          } else {
            responseId.value = null;
            // if new then set the template no need to fetch existing value from db
            formTemplateData.value = _res;
            requiredSync.value = formTemplateData.value.required_sync;
          }
        }
        isPageLoading.value = false;

        // Apply URL query parameters to form fields after form is loaded
        // Add a small delay to ensure UI components are fully initialized
        setTimeout(() => {
          applyUrlQueryParamsToFields();
          initialResponseString.value = JSON.stringify(response.value);
        }, 100);

        if (formTemplateData.value.settings?.on_load) {
          await new Promise((resolve) => setTimeout(resolve, 100)); // Wait 1 second
          await beforeAfterActionsHandler(
            formTemplateData.value.settings.on_load
          );
        }
      });

      async function saveFormResponse(
        createNew = false,
        customResponse = null
      ) {
        try {
          // Only show loader if not embedded
          // if (!props.isEmbedded) loaderObj.value.isLoading = true;
          loaderObj.value.loaderMsg = "Saving Form...";

          const result = await Helper.saveFormResponse({
            createNew,
            customResponse,
            isEmbedded: props.isEmbedded,
            response: toRaw(response.value),
            formProgress: toRaw(formProgress.value),
            formId: getFormId.value,
            responseId: getResponseId.value,
            formTemplateResponseStore: useFormTemplateResponseStore(),
            formTemplateResponse: formTemplateResponse.value,
            shouldShowToast: true,
            emitFunction: props.isEmbedded ? emit : null,
            requiredSync: requiredSync.value
          });

          if (createNew) return result;

          responseId.value = result.id;
          formTemplateResponse.value = result.data;
        } catch (error) {
          errorObj.value.isVisible = true;
          errorObj.value.errorMsg = error;
        } finally {
          // if (!props.isEmbedded) loaderObj.value.isLoading = false;
        }
      }

      async function fetchFormTemplateById() {
        try {
          loaderObj.value.isLoading = true;
          loaderObj.value.loaderMsg = "Fetching Form...";
          // reset the page from list
          await useFormPageStore().resetPageFromList();
          let _res = await formTemplateStore.getFormTemplateById(
            getFormId.value,
            true
          );
          if (_res.error) throw _res.error;
          // setting up the initial response to the store
          let _fieldVals = Helper.deepCopy(
            Helper.generateFormTemplateResponse(_res.data, true)
          );
          await useFormTemplateResponseStore().setInitialResponse(_fieldVals);
          // returning data to the caller
          return _res.data;
        } catch (error) {
          errorObj.value.isVisible = true;
          errorObj.value.errorMsg = error;
        } finally {
          loaderObj.value.isLoading = false;
        }
      }

      async function fetchFormTemplateResponseById(formTemplate) {
        try {
          loaderObj.value.isLoading = true;
          loaderObj.value.loaderMsg = "Fetching Form Response...";
          let _res =
            await useFormTemplateResponseStore().getFormTemplateResponseById(
              getResponseId.value,
              false,
              formTemplate.required_sync
            );
          if (_res.error) throw _res.error;
          // setting up obj with value, here we're passing ref "formTemplateData.value.pages", so it'll update the data reactivily.
          formTemplateResponse.value = _res.data || null;
          // setting up the initial response to the store
          const mergedResponse = Helper.deepMerge(
            Helper.deepCopy(response.value),
            _res.data.response
          );
          await useFormTemplateResponseStore().setInitialResponse(
            mergedResponse
          );
          await useFormPageStore().updateFormProgress(
            _res.data.response_progress
          );

          let _formTemplateData =
            Helper.populateListTemplateFromResponse(
              Helper.deepCopy(formTemplate),
              _res.data ? _res.data.response : null
            ) || formTemplate;

          if (_formTemplateData.pages) {
            for (let i = 0; i < _formTemplateData.pages.length; i++) {
              // if not list then update page
              if (!_formTemplateData.pages[i].is_list) {
                _formTemplateData.pages[i] =
                  await useFormPageStore().updateFormPageFromList(
                    _formTemplateData.pages[i],
                    false,
                    { id: getFormId.value, res: getResponseId.value },
                    formTemplate.required_sync
                  );
              }
            }
          }
          // setting up the value
          formTemplateData.value = _formTemplateData;

          // Apply URL query parameters to form fields after loading existing data
          // Add a small delay to ensure UI components are fully initialized
          setTimeout(() => {
            applyUrlQueryParamsToFields();
          }, 100);
        } catch (error) {
          errorObj.value.isVisible = true;
          errorObj.value.errorMsg = error;
        } finally {
          loaderObj.value.isLoading = false;
        }
      }

      const generatePDF = async (actionType = null) => {
        try {
          // loaderObj.value.isLoading = true;
          loaderObj.value.loaderMsg = "Processing...";

          return await Helper.generatePDF(actionType, {
            userStore,
            getFormId: getFormId.value,
            response: response.value
          });
        } catch (error) {
          errorObj.value.isVisible = true;
          errorObj.value.errorMsg = error;
        } finally {
          // loaderObj.value.isLoading = false;
          loaderObj.value.loaderMsg = "";
        }
      };

      async function openSendEmailDialog(
        navigateHome = false,
        returnPromise = false,
        pdfSrc = null
      ) {
        try {
          // loaderObj.value.isLoading = true;
          loaderObj.value.loaderMsg = "Preparing email...";

          if (pdfSrc) {
            pdfPreviewObj.value.pdfSrc = pdfSrc;
          }

          return await Helper.openSendEmailDialog({
            formId: getFormId.value,
            response: response.value,
            pdfPreviewObj,
            triggerSettingsStore,
            selectedEmailDoc,
            showSendEmailDialog,
            navigateHome,
            returnPromise,
            pdfSrc
          });
        } catch (error) {
          console.error("Error preparing email:", error);
          errorObj.value.isVisible = true;
          errorObj.value.errorMsg = error.message;
          if (returnPromise) {
            throw error;
          }
        } finally {
          // loaderObj.value.isLoading = false;
          loaderObj.value.loaderMsg = "";
        }
      }

      // Watch for shouldValidate prop changes
      watch(
        () => props.shouldValidate,
        async (newVal) => {
          if (newVal && props.isEmbedded) {
            const isValid = await validateFormBeforeAction();
            emit("validation-result", isValid);
          }
        },
        { immediate: false }
      );

      // Update validateFormBeforeAction to return validation result
      async function validateFormBeforeAction() {
        let isValid = true;
        let firstInvalidField = null;

        const currentPage = formTemplateData.value.pages[activeStep.value - 1];

        // Validate current page based on its type
        if (currentPage.is_list) {
          // Handle list pages (QC_SUMMARY_LIST, PROCEDURES_LIST, etc.)
          // These are handled by their respective components
          // For now, we'll assume they're valid unless we add specific validation
          isValid = true;
        } else if (
          currentPage.template_type ===
          Constants.enums.PAGE_TEMPLATE_TYPE.ATTENDEES
        ) {
          // Validate ATTENDEES page using page validation
          const pageValidationResult = Helper.processPageValidation(
            formTemplateData.value.settings,
            currentPage.id,
            response.value
          );

          if (!pageValidationResult.isValid) {
            isValid = false;
            firstInvalidField = pageValidationResult.invalidFields[0];
          }
        } else if (
          currentPage.template_type ===
          Constants.enums.PAGE_TEMPLATE_TYPE.CARD_LIST
        ) {
          // Validate CARD_LIST page using page validation
          const pageValidationResult = Helper.processPageValidation(
            formTemplateData.value.settings,
            currentPage.id,
            response.value
          );

          if (!pageValidationResult.isValid) {
            isValid = false;
            firstInvalidField = pageValidationResult.invalidFields[0];
          }
        } else {
          // Validate regular pages using PageBuilderComponent
          const currentPageBuilder =
            pageBuilderComponents.value[currentPage.id];
          if (currentPageBuilder) {
            const validation = await currentPageBuilder.validatePage();
            if (!validation.isValid) {
              isValid = false;
              firstInvalidField = validation.invalidFields[0];
            }
          }
        }

        if (!isValid && firstInvalidField && !props.isEmbedded) {
          // Only scroll and show toast if not embedded
          // For custom page types, we can't scroll to a specific field
          // so we'll just show the error message
          if (
            currentPage.template_type ===
              Constants.enums.PAGE_TEMPLATE_TYPE.ATTENDEES ||
            currentPage.template_type ===
              Constants.enums.PAGE_TEMPLATE_TYPE.CARD_LIST
          ) {
            console.log("firstInvalidField", firstInvalidField);
            console.log("currentPage", currentPage);

            Helper.showToast(
              "Error",
              "Please complete all required fields on this page",
              "error"
            );
          } else {
            const currentPageBuilder =
              pageBuilderComponents.value[currentPage.id];
            if (currentPageBuilder) {
              currentPageBuilder.scrollToInvalidField(firstInvalidField);
            }
            Helper.showToast(
              "Error",
              "Please fill in all required fields correctly",
              "error"
            );
          }
        }

        return isValid;
      }

      // Handle email sent success callback
      const onSendEmailSuccess = async (emailData) => {
        try {
          await Helper.onSendEmailSuccess({
            emailData,
            selectedEmailDoc,
            uploadStore: useSupabaseStorageUploadStore(),
            formTemplateResponseStore: useFormTemplateResponseStore(),
            fetchFormTemplateResponseById,
            formTemplateData,
            response,
            getResponseId: getResponseId.value,
            router,
            beforeAfterActionsHandler,
            showSendEmailDialog,
            pdfPreviewObj
          });
        } catch (error) {
          console.error("Failed to save email history:", error);
          errorObj.value.isVisible = true;
          errorObj.value.errorMsg = `Email was sent, but we couldn't save the history: ${error.message || "Unknown error"}`;
        }
      };

      // Update the existing onNavigationBtnClick method
      const onNavigationBtnClick = async (
        type,
        beforeActions,
        afterActions,
        config
      ) => {
        try {
          // Add validation before navigation except for previous page
          if (!beforeActions?.some((action) => action?.data?.warn_config)) {
            loaderObj.value.isLoading = true;
          }
          if (type !== Constants.enums.NAVIGATION_BTN_ACTIONS.ON_PREV_PAGE) {
            const isValid = await validateFormBeforeAction();
            if (!isValid) {
              loaderObj.value.isLoading = false;
              loaderObj.value.loaderMsg = "";
              return;
            }
          }

          // Continue with existing navigation logic...
          await Helper.onNavigationBtnClick({
            isDashboard: false,
            type,
            beforeActions,
            afterActions,
            config,
            _preUpdatedResponse,
            saveFormResponse,
            generatePDF,
            pdfPreviewObj,
            router,
            evaluateClickButtonTriggers,
            triggerSettingsStore,
            activeStep,
            response,
            formTemplateData,
            getFormId: getFormId.value,
            localTempStorage,
            confirmationDialogObj,
            isEmbedded: props.isEmbedded,
            onEmbeddedAction: props.onEmbeddedAction,
            beforeAfterActionsHandler: async (
              actions,
              triggerList = [],
              btnParams
            ) => {
              await Helper.beforeAfterActionsHandler({
                actions,
                triggerList,
                _preUpdatedResponse,
                response: response.value,
                formTemplateData: formTemplateData.value,
                pageBuilderComponents: pageBuilderComponents.value,
                localTempStorage,
                getFormId: getFormId.value,
                getResponseId: getResponseId.value,
                showConfirmationDialog,
                router,
                generatePDF,
                pdfPreviewObj,
                openSendEmailDialog,
                templateId: templateId.value,
                formTemplateResponseStore,
                saveFormResponse,
                triggerSettingsStore,
                fetchFormTemplateResponseById,
                btnParams,
                addMoreMenuObj
              });
            },
            addMoreMenuObj
          });
        } catch (error) {
          errorObj.value.isVisible = true;
          errorObj.value.errorMsg = error.message;
        } finally {
          // Hide loader on finally
          loaderObj.value.isLoading = false;
          loaderObj.value.loaderMsg = "";
        }
      };

      const _preUpdatedResponse = ref(null);

      // Takes in an array of action objects and executes them before or after the button event happens
      const beforeAfterActionsHandler = async (
        actions,
        triggerList = [],
        btnParams
      ) => {
        try {
          await Helper.beforeAfterActionsHandler({
            isDashboard: false,
            actions,
            triggerList,
            _preUpdatedResponse,
            response: response.value,
            formTemplateData: formTemplateData.value,
            pageBuilderComponents: pageBuilderComponents.value,
            localTempStorage,
            getFormId: getFormId.value,
            getResponseId: getResponseId.value,
            showConfirmationDialog,
            router,
            generatePDF,
            pdfPreviewObj,
            openSendEmailDialog,
            templateId: templateId.value,
            formTemplateResponseStore,
            saveFormResponse,
            triggerSettingsStore,
            fetchFormTemplateResponseById,
            btnParams,
            route,
            addMoreMenuObj
          });
        } catch (error) {
          errorObj.value.isVisible = true;
          errorObj.value.errorMsg = error.message;
        }
      };

      const onErrorDialogClose = () => {
        errorObj.value.isVisible = false;
        errorObj.value.errorMsg = "";
      };

      const updatePageData = (pageIndex, itemIndex, data) => {
        // for now commented but would have to adjust the logic here.
        // formTemplateData.value.pages[pageIndex].list_items[itemIndex] = data;
      };

      const isButtonVisible = (button) => {
        // If hideInForm is true hide from form
        if (button.hideInForm) {
          return false;
        }

        if (Helper.isStringValueExist(button.if_condition)) {
          return Helper.evaluateTriggerConditions(
            button.if_condition,
            Helper.deepCopy(response.value)
          );
        }
        return true;
      };

      // Handles step navigation with validation when moving forward
      const handleStepClick = async (targetStep) => {
        if (formTemplateData.value.settings?.disable_stepper_navigation) {
          return;
        }

        if (targetStep > activeStep.value) {
          const isValid = await validateFormBeforeAction();
          if (!isValid) {
            return;
          }
        }
        activeStep.value = targetStep;
      };

      const visiblePages = computed(() => {
        if (!formTemplateData.value.pages) return [];

        return formTemplateData.value.pages.filter((page) => {
          if (!page.show_condition) return true;

          return Helper.evaluateTriggerConditions(
            page.show_condition,
            Helper.deepCopy(response.value)
          );
        });
      });

      watch(
        () => activeStep.value,
        async (newStep) => {
          // Get the step element
          const scrollToStep = () => {
            const stepEl = document.querySelector(`[data-step='${newStep}']`);
            if (stepEl) {
              stepEl.scrollIntoView({ behavior: "smooth", block: "center" });
              return true;
            }
            return false;
          };

          // Try scrolling immediately
          if (!scrollToStep()) {
            // If failed, retry every 1 second until successful
            const interval = setInterval(() => {
              if (scrollToStep()) {
                clearInterval(interval);
              }
            }, 1000);

            // Clear interval after 5 seconds to prevent infinite retries
            setTimeout(() => clearInterval(interval), 5000);
          }
        },
        { deep: true }
      );

      const handleTitleClick = () => {
        const navigateBack = () => {
          if (formTemplateData.value.settings?.programatic_back_url) {
            router.back();
          } else if (
            formTemplateData.value.settings?.redirect_url &&
            formTemplateData.value.settings?.show_back_button
          ) {
            router.push(formTemplateData.value.settings.redirect_url);
          } else {
            router.back();
          }
        };

        if (
          !formTemplateData.value.settings?.redirect_url &&
          !formTemplateData.value.settings?.programatic_back_url
        )
          return;

        // console.log("initialResponseString", initialResponseString.value);
        // console.log("response", JSON.stringify(response.value));

        if (initialResponseString.value !== JSON.stringify(response.value)) {
          confirmationDialogObj.value.headerMsg =
            formTemplateData.value.settings.navigation_warning_header ||
            "Warning - Unsaved Changes";
          confirmationDialogObj.value.message =
            formTemplateData.value.settings.navigation_warning_message ||
            "You may have unsaved changes. If you leave now, your data will be lost. Are you sure you want to continue?";
          confirmationDialogObj.value.isVisible = true;
          confirmationDialogObj.value.onConfirm = () => {
            navigateBack();
          };
        } else {
          navigateBack();
        }
      };

      const cmaNumber = computed(() => {
        return response.value?.["78d84465-2cf4-498b-905d-d930f8007a57"]?.[
          "effba4e3-6abc-49f3-adef-6c58b0fde198"
        ]?.["0f5c5f18-9e93-4201-9c73-946c0a74b1f3"];
      });

      const cmaYear = computed(() => {
        return new Date(
          response.value?.["78d84465-2cf4-498b-905d-d930f8007a57"]?.[
            "effba4e3-6abc-49f3-adef-6c58b0fde198"
          ]?.["a5eef1b9-8a3d-4775-9c60-bd9885efd304"]
        ).getFullYear();
      });

      return {
        updatePageData,
        route,
        router,
        Constants,
        Helper,
        errorObj,
        pdfPreviewObj,
        getFormId,
        getResponseId,
        activeStep,
        formTemplateData,
        formTemplateResponse,
        onNavigationBtnClick,
        onErrorDialogClose,
        confirmationDialogObj,
        isEmbedded: props.isEmbedded,
        showButtons: props.showButtons || false,
        userStore,
        openSendEmailDialog,
        onSendEmailSuccess,
        showSendEmailDialog,
        selectedEmailDoc,
        showEmailPreview,
        pageBuilderComponents,
        isButtonVisible,
        promiseDialogState,
        showConfirmationDialog,
        validateFormBeforeAction,
        saveFormResponse,
        loaderObj,
        handleStepClick,
        visiblePages,
        handleTitleClick,
        addMoreMenuObj,
        response,
        cmaNumber,
        cmaYear
      };
    }
  });
</script>
